// @flow
import {fromJS} from 'immutable';
import {Store} from 'client/framework';
import submissionResetModalActions from './SubmissionResetModal.actions';
import {StudentModelV2} from 'resources/GeneratedModels/Student/StudentModel.v2';

export default class SubmissionResetModalStore extends Store {
  constructor(name: string) {
    super(name);

    this.initialData = fromJS({
      activeAssignment: null,
      activeStudent: null
    });
    this.setInitialData(this.initialData);
    this.handleTargeted(
      submissionResetModalActions.SET_ACTIVE_ASSIGNMENT,
      this.setProperty('activeAssignment')
    );
    this.handleTargeted(
      submissionResetModalActions.SET_ACTIVE_STUDENT,
      this.setProperty('activeStudent')
    );
  }

  getActiveAssignment() {
    return this.readData('activeAssignment');
  }

  getActiveStudent(): StudentModelV2 {
    return this.readData('activeStudent');
  }
}
